export default {
  meta: {
    title: '拓店管理-开发人员提报报表',
    url: '/fishtogether/developerreport', // 埋点用，记录所属模块
  },
};
